<template>
	<div class="chat-container w-100 position-relative bg-white">
    <div id="hotel-spa-select"></div>
    <div v-if="is_load" class="w-100 py-5 text-center">
      <loader />
    </div>

    <template v-else>
      <ErrorMessage v-if="error != ''" :message="error" />
      <template v-else>
        <!-- NAVBAR -->
        <transition name="fade">        
          <div class="position-relative z-index-1028" v-if="scrollPosition>60">
            <div class="row no-gutters justify-content-center">
              <div class="fixed-top d-block nav-bottom">
                <div class="custom-container-fluid px-0">
                  <div class="row justify-content-center no-gutters">
                    <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                      <div class="bg-white" :class="{'box-shadow-nav':scrollPosition>60}">
                        <div class="container px-4 w-100 py-1">
                          <div class="row no-gutters pt-2 pb-3 m-0 w-100">
                            <div class="col-1">
                              <div class="">
                                <router-link :to="'/'+getMerchant().code+'/concierge/spa'">
                                  <img src="../../../../assets/img/icon/back.png" class="mt-1 top-2 position-relative" width="20" style="top:1px">
                                </router-link>
                              </div>
                            </div>
                            <div class="col-11">
                              <div class="">
                                <p class="mb-0 body-1-2 nav-hotel ml-3 mt-1 text-truncate" v-if="scrollPosition>225">{{product.name}}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>

        <!-- SLIDER/IMAGE -->
        <div>
          <router-link :to="'/'+getMerchant().code+'/concierge/spa'">
            <div class="d-inline-block px-2 pb-2 pt-1 rounded-3 bg-back mt-4 mx-4 cursor-pointer position-absolute" width="33" style="z-index: 1038">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M16.9107 10.6857C17.2435 10.6399 17.5 10.3504 17.5 10.0001C17.5 9.61795 17.1947 9.30816 16.8182 9.30816L4.83339 9.30816L9.16276 4.93222L9.22893 4.85475C9.42753 4.58429 9.40631 4.19984 9.16475 3.95368C8.89904 3.6829 8.46733 3.68199 8.20052 3.95165L2.71023 9.50036C2.67753 9.53215 2.64794 9.56722 2.62198 9.60504C2.43614 9.87525 2.46234 10.2501 2.70056 10.4908L8.20056 16.0484L8.27717 16.1152C8.54452 16.3156 8.92325 16.2925 9.16479 16.0463C9.43048 15.7755 9.42955 15.3374 9.16271 15.0677L4.83231 10.692L16.8182 10.692L16.9107 10.6857Z" fill="white"/>
              </svg>
            </div>
          </router-link>
          <flickity v-if="product.image_list.length > 0" ref="flickity" class="room-detail text-center" :options="flickityOptions">
            <div class="carousel-cell w-100" v-for="image_product in product.image_list">
              <div class="w-100" style="height: 230px !important;">
                <img :src="image_product.image_url" class="img-fit" height="150">
              </div>
            </div>
          </flickity>
          <div v-else class="w-100" style="height: 230px !important;">
            <img :src="product.image_url" class="img-fit" height="150">
          </div>
        </div>

        <!-- PRODUCT DATA -->
        <div class="bg-white pb-2 position-relative">
          <div class="container px-4 pb-4 pt-3 border-bottom-5-light">
            <p class="mb-1 body-1-4 text-18">{{product.name}}</p>
            <div class="mb-3">
              <p v-if="is_decrease_promo" class="mb-0 ls-0-1 text-14 text-light-menu text-line-through d-inline-block align-middle">{{formatCurrency(promotion_price)}}</p>
              <p class="mb-0 body-2-2 text-16 font-bold text-orange d-inline-block align-middle">{{formatCurrency(final_price)}} <span class="body-2 font-semibold text-14">/ {{product.guest_include == 1 ? $t('general.person') : product.guest_include+' '+$t('general.persons') }}</span></p>
            </div>
            <p class="mb-0 body-3-3 text-14 font-regular">{{product.description}}</p>
            <!-- WHATSAPP -->
            <div class="mt-3">
              <whatsappLink :name="product.name" :description="$t('hotel.concierge.fitur.ask-the-hotel-about-this-package')" />
            </div>
          </div>
          <div class="container px-4 pb-4">
            <p class="mb-3 mt-4 body-2-2 text-16 font-bold">{{$t('hotel.concierge.fitur.fill-in-the-data-to-order')}}</p>
            <div class="row pt-1 slim-grid-row">
              <div class="col-6">
                <!-- DATE -->
                <p class="mb-2 body-3 mb-1 d-block w-100 text-13 text-black">{{$t('hotel.concierge.fitur.date-selected')}}</p>
                <div class="border-semi-grey radius-6 py-2 px-1 bg-light">
                  <div class="row no-gutters">
                    <div class="col-2 align-self-center">
                      <i class="simple-icon-calendar text-16"></i>
                    </div>
                    <div class="col-10 align-self-center">
                      <p class="mb-0 body-2-2 font-regular">{{$formatDateWithoutMonth(formatDate(getConciergeOrder().date))}}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-6">
                <!-- TIME -->
              <p class="mb-2 body-3 mb-1 d-block w-100 text-13 text-black">{{$t('hotel.concierge.select-service-time')}}<span class="text-danger">*</span></p>
              <v-timepicker 
                v-model="form.time" 
                hide-clear-button
                close-on-complete 
                format="HH:mm" 
                :minute-interval="15"
                hour-label="Hour" 
                minute-label="Minute"
                input-width="100%"
                class="" />
              </div>
            </div> 

            <!-- GUEST INCLUDED -->
            <div class="pt-4">
              <p class="mb-2 body-3 mb-1 d-block w-100 text-13 text-black">{{$t('hotel.concierge.select-number-of-person')}}<span class="text-danger">*</span></p>
              <p v-if="product.guest_include > 1" class="mb-0 mt-2 body-3-3">{{$t('hotel.concierge.one-package-for')}} {{product.guest_include}} {{$t('general.people')}}</p>
            </div>
            <div class="row slim-grid-row">
              <div class="col-4" v-for="data in 3">
                <div class="w-100 position-relative">
                  <div 
                    @click="form.qty = data"
                    class="w-100 radius-6 body-2-1 p-2 text-truncate" 
                    :class="form.qty == data ? 'border-green input-custom-padding text-green':'border-semi-grey cursor-pointer input-custom-padding-equal text-center'">
                    <i v-if="form.qty == data" class="simple-icon-check text-green text-16 py-2 pl-2 pr-1 position-relative top-2"></i>
                    {{data}} {{product.guest_include > 1 ? $t('general.package') : $t('general.person')}}
                  </div>
                </div>
              </div>
            </div>

            <!-- GENDER OF THERAPIST -->
            <template v-if="general.use_gender_therapist_choices">
              <p class="pt-4 mb-2 body-3 mb-1 d-block w-100 text-13 text-black">{{$t('hotel.concierge.preferred-gender-of-therapist')}}<span class="text-danger">*</span></p>
              <div class="row pt-2 slim-grid-row">
                <div class="col-4" v-for="data in specialist">
                  <div class="w-100 radius-6 body-2-1 p-2 text-truncate  delay cursor-pointer" 
                  :class="form.gender_therapist == data ? 'border-green input-custom-padding text-green':'border-semi-grey cursor-pointer input-custom-padding-equal text-center'"
                  @click="form.gender_therapist = data">
                    <i v-if="form.gender_therapist == data" class="simple-icon-check text-green text-16 py-2 pl-2 pr-1 position-relative top-2"></i>
                    {{data}}
                  </div>
                </div>
              </div>
            </template>

            <!-- PLACE -->
            <template v-if="general.use_place_choices">
              <p class="pt-4 mb-2 body-3 mb-1 d-block w-100 text-13 text-black">{{$t('hotel.concierge.choose-the-place-of-service')}}<span class="text-danger">*</span></p>
              <div class="row slim-grid-row">
                <div class="col-6" v-for="data in general.place_choices">
                  <div class="w-100 radius-6 body-2-1 p-2 text-truncate  delay cursor-pointer" 
                  :class="form.place == data ? 'border-green input-custom-padding text-green':'border-semi-grey cursor-pointer input-custom-padding-equal text-center'"
                  @click="form.place = data">
                    <i v-if="form.place == data" class="simple-icon-check text-green text-16 py-2 pl-2 pr-1 position-relative top-2"></i>
                    {{data}}
                  </div>
                </div>
              </div>
            </template>


            <!-- NOTES -->
            <p class="pt-4 mb-2 body-3 mb-1 d-block w-100 text-13 text-black">{{$t('hotel.concierge.add-note')}}</p>
            <div class="w-100 position-relative">
              <textarea
                rows="3"
                :placeholder="$t('hotel.concierge.fitur.cart.placeholder-note')"
                class="body-2-1 w-100 border-semi-grey radius-6 input-custom-padding"
                v-model="form.notes">
              </textarea>
              <i class="simple-icon-notebook text-semi-dark text-16 position-absolute icon-form-position"></i>
            </div>

          </div>
          <div class="container px-4">
            <div class="row slim-grid-row">
              <div v-if="cart.is_cart" class="col-6">
                <button type="button" @click="resetCart" class="g-btn g-btn-dark-outline g-btn-lg w-100">
                  <pulse-loader :loading="push_loader_cancel" color="#fff" v-if="push_loader_cancel"></pulse-loader>
                  <template v-else>
                    {{$t('hotel.action.delete')}}
                  </template>
                </button>
              </div>
              <div :class="{'col-12': !cart.is_cart,'col-6': cart.is_cart}">
                <button   
                  type="button" 
                  class="g-btn g-btn-primary g-btn-lg w-100" 
                  :disabled="!is_form_valid" 
                  :class="{'button-disabled': !is_form_valid}"
                  @click="submitData">
                  <pulse-loader :loading="push_loader" color="#fff" v-if="push_loader"></pulse-loader>
                  <template v-else>
                    {{cart.is_cart ? $t('hotel.action.save-changes') : $t('hotel.action.book-now')}}
                  </template>
                </button>
              </div>
            </div>
          </div>
          <div style="height: 15px;"></div>
        </div>
      </template>
    </template>
    <popupWarningAddProduct v-if="show_popup" @close="show_popup = false"></popupWarningAddProduct>
    <!-- <bottom-navbar></bottom-navbar> -->
  </div>
</template>
<script>
  import {mapGetters,mapMutations} from 'vuex';
  import {get} from '@/services/index.js';
  import Flickity from 'vue-flickity';
  import BottomNavbar from '@/components/hotel/BottomNavbar';
  import PopUpSuccess from '@/components/dev/PopUpSuccess';
  import PopUpBackground from '@/components/dev/PopUpBackground';
  import {formatCurrency,customFormatDateTime,calculateFinalPriceConcierge} from '@/utils/index.js'
  import whatsappLink from '@/components/hotel/concierge/general/whatsappLink';

  import moment from 'moment';

  export default{
    components: {
      Flickity,
      BottomNavbar,
      PopUpSuccess,
      PopUpBackground,
      whatsappLink
    },
    metaInfo(){
      return {
        title: 'Spa Detail',
        titleTemplate: this.getMetaTitleTemplate()
      }
    },
    data() {
      return {
        scrollPosition: null,
        flickityOptions: {
          initialIndex: 0,
          autoPlay: 3000,
          prevNextButtons: false,
          pageDots: true,
          adaptiveHeight: false,
          draggable: true,
          wrapAround: true,
          cellAlign: 'left'
        },
        specialist: ['Random','Male','Female'],
        is_load: true,
        push_loader: false,
        push_loader_cancel: false,
        error: '',
        guest_include: 1,
        product:{},
        general: {},
        form:{
          date: new Date(),
          time: "09:00",
          qty: 0,
          gender_therapist: '',
          place: '',
          notes: ''
        },
        minDate: moment().toDate(),
        maxDate: moment().add(1,'d').toDate(),
        show_popup: false
      }
    },
    computed:{
      base_price(){
        return Object.keys(this.product).length > 0 ? this.product.price : 0
      },
      final_price(){
        return calculateFinalPriceConcierge(this.base_price)
      },
      promotion_price(){
        if(this.base_price.promotion_amount == 0){
          return 0
        }else{
          return this.base_price.tax_service_calculation_type == 'INCLUDE' ? this.base_price.price_sell_base : this.base_price.price_sell
        }
      },
      is_decrease_promo(){
        if(this.base_price.promotion_amount == 0){
          return false
        }else{
          return this.base_price.promotion_type == 'INCREASE' ? false : true
        }
      },
      is_form_valid(){
        if(this.form.time == ''){
          return false
        }else if(this.form.qty == 0){
          return false
        }else if(this.general.use_gender_therapist_choices && this.form.qty == 0){
          return false
        }else if(this.general.use_place_choices && this.form.place == ''){
          return false
        }else{
          return true
        }
      },
      cart(){
        let cart = {
          data : {},
          is_cart: false
        }
        let record = this.getConciergeOrder().custom.findIndex(x=>x.product.id == this.$route.params.id)
        if(record != -1){
          cart = {
            data: this.getConciergeOrder().custom[record],
            is_cart: true
          }
        }

        return cart
      }
    },
    mounted() {
      window.addEventListener('scroll', this.updateScroll);
      document.getElementById('hotel-spa-select').scrollIntoView({
        behavior: 'smooth'
      });
      this.loadProductDetail()
      if(this.cart.is_cart){
        this.form = JSON.parse(JSON.stringify(this.cart.data.form))
      }
    },
    methods: {
      ...mapGetters(['getMerchant','getConciergeOrder','getConciergeReservation','getConciergeAuth','getMetaTitleTemplate']),
      ...mapMutations(['setConciergeOrderCustom','removeConciergeOrderCustom','setUpdateConciergeOrderCustom','setConciergeOrderCustomModule']),
      updateScroll() {
          this.scrollPosition = window.scrollY
      },
      formatDate(date) {
        return customFormatDateTime(date, null, 'DD MMM YYYY')
      },
      formatDay(date){
        return customFormatDateTime(date, null, 'dddd')
      },
      formatCurrency(value){
        return formatCurrency(value);
      },
      submitData(){
        this.push_loader = true
        this.form.date = this.getConciergeOrder().date
        let params = {
          product : this.product,
          form : this.form
        }
        setTimeout(()=>{
          if(this.cart.is_cart){
            this.setUpdateConciergeOrderCustom(params)
          }else{
            this.setConciergeOrderCustom(params)
            this.setConciergeOrderCustomModule("spa")
          }
          this.push_loader = false
          this.backToPrev()
        },1000)
        // if(this.getConciergeReservation().status == 'CHECKIN'){
        // 
        // } else{
        //   this.show_popup = true
        // }
      },
      resetCart(){
        this.push_loader_cancel = true
        let params = {
          product : this.product,
          form : this.form
        }
        setTimeout(()=>{
          this.removeConciergeOrderCustom(this.$route.params.id)
          this.push_loader_cancel = false
          this.backToPrev()
        },1000)
      },
      backToPrev(){
        if(this.$route.query.prev_page == 'cart'){
          this.$router.push("/"+this.getMerchant().code+"/concierge/spa/cart")
        }else{
          this.$router.push("/"+this.getMerchant().code+"/concierge/spa")
        }
      },


      // API FUNCTION
      loadProductDetail(){
        this.is_load = true
        this.error = ''
        get("CONCIERGE","spa/product/"+this.$route.params.id,{
          merchant_id: this.getMerchant().id
        }).then(response=>{
          let res = response.data
          if(res.success){
            this.product = res.data
            this.loadGeneralSetting()
            // this.loadReservation()
          }else{
            this.error = res.message
            this.is_load = false
          }
        })
      },
      loadGeneralSetting(){
        get("CONCIERGE","spa/general",{
          merchant_id: this.getMerchant().id
        }).then(response=>{
          let res = response.data
          if(res.success){
            this.general = res.data
          }else{
            this.error = res.message
          }
          this.is_load = false
        })
      },
      loadReservation(){
        get("CONCIERGE",`reservation/${this.getConciergeAuth().detail_id}/${this.getConciergeAuth().folio}`,{
          merchant_id: this.getMerchant().id
        },'concierge_pin').then(response=>{
          let res = response.data 
          if(res.success){
            this.maxDate = moment(res.data.departure_date,'YYYY-MM-DD').toDate()
          }else{
            this.$router.push(`/${this.getMerchant().code}/concierge`)
          }
        })
      },
    },
  }
</script>
<style>
.vue__time-picker input.display-time{
  border: 1px solid #ddd!important;
  border-radius: 6px!important;
  padding: 8px 12px!important;
  height: auto!important;
}
.input-custom-padding{
  padding: 8px 8px 8px 42px;
}
.input-custom-padding-equal{
  padding: 8px;
}
.icon-form-position{
  top: 11px;
  left: 12px;
}
</style>


// WEBPACK FOOTER //
// src/pages/hotel/concierge/spa/SpaSelect.vue